import React, { useState, useEffect } from 'react';
import './home.scss';
import { PlaySquare, Image as ImageIcon, BookOpen, Eye, X, Download, Wand2 } from 'lucide-react';

const Home = () => {
  const [activeTab, setActiveTab] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);

  // 🔥 NEW STATES
  const [categories, setCategories] = useState([]);
  const [videos, setVideos] = useState({});
  const [loading, setLoading] = useState(true);

  const openVideo = (video) => setSelectedVideo(video);
  const closeVideo = () => setSelectedVideo(null);

  const handleCreateSimilar = (video) => {
    window.location.href = `/create-video?ref=${video.id}`;
  };

  // 🔥 FETCH API
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch('https://api.zulluai.com/api/homeVideo/all');
        const data = await res.json();

        if (data.success) {
          setCategories(data.categories);
          setVideos(data.videos);

          // Set default tab
          if (data.categories.length > 0) {
            setActiveTab(data.categories[0]);
          }
        }
      } catch (err) {
        console.error('Error fetching videos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div className="zullu-app">

      {/* Fixed Top Features */}
      <section className="feature-header">
        <div className="feature-row">
          <div className="feat-card purple" onClick={() => window.location.href = '/create-video'}>
            <PlaySquare size={24} />
            <span>Image to Video</span>
          </div>
          <div className="feat-card blue" onClick={() => window.location.href = '/create-image'}>
            <ImageIcon size={24} />
            <span>Text to Image</span>
          </div>
          <div className="feat-card dark" onClick={() => window.location.href = '/create-story'}>
            <BookOpen size={24} />
            <span>Story Creation</span>
          </div>
        </div>
      </section>

      {/* Categories */}
      <div className="tabs-container">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`tab ${activeTab === cat ? 'active' : ''}`}
            onClick={() => setActiveTab(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Loading State */}
      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Loading videos...
        </div>
      )}

      {/* Video Grid */}
      {!loading && (
        <section className="video-feed-grid">
          {videos[activeTab]?.map((item) => (
            <div key={item.id} className="video-item" onClick={() => openVideo(item)}>
              <div className="video-wrapper">
                <video
                  src={item.videoUrl}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
                <div className="video-content-overlay">
                  <p className="v-title">{item.title}</p>
                  <div className="v-footer">
                    <span className="v-author">@{item.author}</span>
                    <span className="v-views">
                      <Eye size={12} /> {item.views}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>
      )}

      {/* Full Screen Modal */}
      {selectedVideo && (
        <div className="player-modal">
          <div className="modal-header">
            <button className="modal-btn" onClick={closeVideo}>
              <X size={24} />
            </button>
            <div className="header-right">
              <a href={selectedVideo.videoUrl} download className="modal-btn">
                <Download size={22} />
              </a>
            </div>
          </div>

          <div className="modal-content-wrapper">
            <div className="modal-body">
              <video
                src={selectedVideo.videoUrl}
                controls
                autoPlay
                loop
                playsInline
              />
            </div>

            <div className="create-similar-panel">
              <div className="panel-inner">
                <div className="video-info-lite">
                  <h3>{selectedVideo.title}</h3>
                  <p>Inspired by @{selectedVideo.author}</p>
                </div>
                <button
                  className="create-sim-btn"
                  onClick={() => handleCreateSimilar(selectedVideo)}
                >
                  <Wand2 size={20} />
                  <span>Create Similar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <div className="fab-wrapper" onClick={() => window.location.href = '/create-video'}>
        <button className="main-fab">
          <Wand2 size={20} />
          <span>Start Creating</span>
        </button>
      </div>
    </div>
  );
};

export default Home;